import { Navigate, Outlet, RouteObject } from "react-router-dom";
import { ConfiguratorProvider } from "datasets/pages/settings/contexts/configurator";
import ConfigOverview from "datasets/pages/settings/pages/ConfigOverview";
import DomainConfigForm from "datasets/pages/settings/pages/DomainConfigForm";
import yn from "yn";
import { useSafeRoutes } from "~/hooks/useSafeRoutes";
import { ROUTE_404 } from "~/router/constants";

const { VITE_CE_CONFIGURATOR_ENABLED } = import.meta.env;

export const routeDefinitions: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="domains" replace />,
  },
  {
    path: "domains",
    element: <ConfigOverview />,
  },
  {
    path: "domains/:domainId",
    element: <DomainConfigForm />,
  },
];

const Configurator = () => {
  const routes = useSafeRoutes(routeDefinitions);

  if (!yn(VITE_CE_CONFIGURATOR_ENABLED)) {
    return <Navigate to={ROUTE_404} replace />;
  }

  return (
    <ConfiguratorProvider>
      {routes}
      <Outlet />
    </ConfiguratorProvider>
  );
};

export default Configurator;
